import React from 'react';
import { Nullable } from 'global';
import { formatCurrency } from 'utils';
import { Stack, Typography } from '@mui/material';

import { QuoteCalcColumnTotals, QuoteCalcViewModel } from '../../../../api/types';

interface Props {
  priceCalc: Nullable<QuoteCalcViewModel>;
  field: keyof QuoteCalcColumnTotals;
}

export const EquipmentChargeColumnTotalCell = ({ field, priceCalc }: Props) => {
  return (
    <Stack>
      <Typography>{formatCurrency(priceCalc?.totals?.columnTotals?.[field] ?? null, true)}</Typography>
    </Stack>
  );
};
